export default {"src":"/_next/static/media/investment-plan.abf8e016.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};